import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListTickerComponent } from './list-ticker/list-ticker.component';

const routes: Routes = [
  {
    path: '',
    component: ListTickerComponent,
  },
  { path: '', pathMatch: 'full', redirectTo: 'catalog/ticker' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TickerRoutingModule {}
